import * as React from 'react';
import {Link} from 'react-router-dom';
import LegalPage, {LEGAL_ADDRESS, LEGAL_ENTITY} from '../components/LegalPage';

// Linked from the Facebook app's "Data deletion instructions URL" setting.
const DataDeletionPage: React.FC = () => (
    <LegalPage eyebrow="Legal" title="Data Deletion" updated="October 5, 2026">
        <section>
            <p>
                You can ask {LEGAL_ENTITY} to delete the information we hold about you at any time, including
                everything we received when you signed in with Facebook.
            </p>
        </section>

        <section>
            <h2>How to request deletion</h2>
            <ul>
                <li>
                    Send a request through our <Link to="/contact">contact page</Link> with the subject
                    "Delete my data", using the name and email address on your account. Or write to
                    {' '}{LEGAL_ENTITY}, {LEGAL_ADDRESS}.
                </li>
                <li>We'll confirm we've received it and complete the deletion within 30 days.</li>
            </ul>
        </section>

        <section>
            <h2>What gets deleted</h2>
            <p>
                Your account and Facebook profile data (name, email, profile photo, Facebook ID, and the list of
                Pages you manage), plus your saved contact details. If you have open rentals, unpaid invoices, or
                records we're required to keep for tax or legal reasons, we'll keep only those records, for only as
                long as required, and tell you which ones.
            </p>
        </section>

        <section>
            <h2>Removing our app from Facebook</h2>
            <p>
                You can also stop Facebook from sharing anything further with us: on Facebook, go to Settings &amp;
                privacy → Settings → Apps and websites, choose Luminx / Love Wins Media, and select Remove. This
                stops new data from reaching us; send a request as above to delete what we already have.
            </p>
        </section>

        <section>
            <p>
                See our <Link to="/privacy">Privacy Policy</Link> for what we collect and why.
            </p>
        </section>
    </LegalPage>
);

export default DataDeletionPage;
